<template>
  <Container type="card-full" v-loading="loading">
    <div style="margin: 30px 0">
      <vxe-button type="primary" v-if="+type === 4 && +project.projectjjbgstatus === 1" @click="saveCGBG">保存
      </vxe-button>
      <vxe-button type="primary" class="vxe-btn" @click="checkDialog(2)"
        v-if="+type === 4 && +project.projectjjbgstatus === 1" :loading="btnLoading">提交</vxe-button>
      <!-- <vxe-button type="primary" class="vxe-btn"  @click="checkDialog(3)" v-if="displayOk"  :loading="btnLoading">审核</vxe-button> -->
    </div>
    <!-- <div slot="header">
      <el-button type="primary" v-if="type === 1 || type === 2" @click="addOrEdit" :loading="btnLoading">保存</el-button>
    </div> -->
    <div class="main">
      <el-form ref="ruleForm" :model="project" label-position="right" class="mainfrom">
        <div class="content">
          <el-form-item label="项目编号">
            {{ project.projectcode }}
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item label="项目名称">
            {{ project.projectname }}
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item label="采购人">
            {{ project.purchase_comname }}
          </el-form-item>
        </div>
        <div class="content">
          <el-form-item label="采购报告">
            <div class="file">
              <div class="uploadbtn">
                <upload-btn @changed="setfile" text="上传附件"></upload-btn>
              </div>
              <div v-if="appendList.length" class="filelist">
                <div v-for="(item, index) in appendList" :key="index" class="fileitem">
                  <div class="name" @click="downFile(item.appendurl)">
                    <a :src="uploadAddr + item.appendurl">{{
                    item.appendfilename
                    }}</a>
                  </div>
                  <div class="btn" @click="delappend(item)">
                    <span>删除</span>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="content" style="width: 1200px" >
          <el-form-item :label="+project.projectstatus == 20 || +project.projectstatus == 10 ? '报告内容': '选择模板'">
            <div v-if="+type === 4 && +project.projectjjbgstatus === 1">
              <el-select v-model="ReportValue" clearable placeholder="请选择" @change="setReport" v-if="+project.projectstatus !== 20 && +project.projectstatus !== 10">
                <el-option v-for="item in ReportOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <div ref="editorCGNR" style="margin-top: 10px"></div>
            </div>
            <div v-else v-html="project.projectjjcontent"></div>
          </el-form-item>
        </div>
        <div class="content" style="width: 1200px" >
          <el-form-item label="成交确认函" v-if="+project.projectstatus !== 20 && +project.projectstatus !== 10">
            <div v-if="+type === 4 && +project.projectjjbgstatus === 1">
              <el-select v-model="ConfirmationValue" clearable placeholder="请选择" @change="setConfirmation">
                <el-option v-for="item in ConfirmationOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <div ref="editorConfirma_Letter" style="margin-top: 10px"></div>
            </div>
            <div v-else v-html="project.projectjjcontent"></div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-dialog :close-on-click-modal="false" :title="status === 2 ? '提交' : '审核'" :visible.sync="dialogVisible"
      width="720px" :modal-append-to-body="false">
      <div v-if="status === 3">
        <div class="view-container">
          <div class="view-box">
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">报告结果</div>
                <div class="view-value">
                  <el-radio v-model="projectjjbgstatus" :label="3">同意</el-radio>
                  <el-radio v-model="projectjjbgstatus" :label="4">不同意</el-radio>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">审核意见</div>
                <div style="width: 380px">
                  <el-input type="textarea" :autosize="{ minRows: 5 }" :rows="5" v-model.trim="checkdesc_Audit"
                    :maxlength="255" show-word-limit></el-input>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label"></div>
                <div class="view-value">
                  <vxe-button type="primary" class="vxe-btn" @click="submit(status)" :loading="btnLoading">保存
                  </vxe-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="status === 2">
        <div class="view-container">
          <div class="view-box">
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">提交意见</div>
                <div style="width: 380px">
                  <el-input type="textarea" :autosize="{ minRows: 2 }" v-model.trim="checkdesc_submit" :maxlength="255"
                    show-word-limit></el-input>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label"></div>
                <div class="view-value">
                  <vxe-button type="primary" class="vxe-btn" @click="submit(status)" :loading="btnLoading">提交
                  </vxe-button>
                  <vxe-button type="primary" class="vxe-btn" @click="sendMsg(status)" :loading="btnLoading">提交并提醒采购人审核
                  </vxe-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import E from "wangeditor";
import config from "../../assets/config";
import uploadBtn from "../common/uploadBtn";
import common from "@/mixin/common";
import dayjs from "dayjs";

export default {
  name: "projectReportE",
  mixins: [common],
  data() {
    return {
      loading: false,
      btnLoading: false,
      checkdesc_Audit: "",
      checkdesc_submit: "",
      dialogVisible: false,
      templateFlg: 1,
      type: this.$route.params.type,
      editorCGNR: "",
      editorCGNRContent: "",
      editorConfirma_Letter: "",
      editorConfirma_Letter_Content: "",
      project: {},
      pbtList: [],
      psuList: [],
      ReportValue: "",
      ReportOptions: [],
      ConfirmationValue: "",
      ConfirmationOptions: [],
      psu_Bidding: [],
      appendList: [],
      status: 0,
      tm2: ``,
    };
  },
  async activated() {
    this.init();
    await this.getModel();
    await this.getAppendList();
    if (+this.type === 4 && +this.project.projectjjbgstatus === 1) {
      await this.initEditorCGNR();
      await this.initEditorConfirmletter();
    }
    this.ReportOptions = await this.getTemplateOptions(2);
    this.ConfirmationOptions = await this.getTemplateOptions(3);
  },
  components: { uploadBtn },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
  },
  deactivated() {
    this.$destroy();
  },
  methods: {
    init() {
      this.appendList = [];
    },
    async saveCGBG() {
      if (!this.editorConfirma_Letter_Content) {
        this.$message.warning("请填写完内容后再保存");
        return;
      }

      if (!this.editorCGNRContent && +this.project.projectstatus !== 20) {
        this.$message.warning("请填写完内容后再保存");
        return;
      }
      let from = {};
      from.projectid = this.project.projectid;
      from.projectjjcontent = this.editorCGNRContent;
      from.projectconfirmletter = this.editorConfirma_Letter_Content;
      from.appendList = this.appendList;
      let data = await request({
        url: "/xmgl/project/saveCGBG",
        method: "post",
        data: from,
      });
      if (+data.issuccess === 1) {
        this.$message.success(`保存成功！`);
        return;
      } else {
        this.$message.error(`保存失败！`);
        return;
      }
    },
    async getAppendList() {
      let res = await request({
        method: "get",
        url: "/ywgl/append/getAppendListByFromId",
        params: {
          appendfromid: this.$route.params.projectid,
          appendfromtype: 20,
        },
      });
      this.appendList = res;
    },
    async getModel() {
      this.loading = true;
      this.btnLoading = true;
      let selectField = ` projectcode,projectquotationmode,projectlimitamt,projectpuserid,projectjjfile,prsflg,projectconfirmletter,projectcosid,projectid,projectname,projectdesc,prsbjendtime,projectjjbgstatus,projectjjcontent,prsbjtimes,prsbjbegtime,projectstatus`;
      let res = await request({
        method: "get",
        url: "/xmgl/tmpl/getTemplateProjectInfo",
        params: { projectid: this.$route.params.projectid, selectField },
      });
      this.project = res.data[0];
      this.pbtList = res.data_pbt;
      this.psuList = res.psuList;
      res.data_psu = res.data_psu.map(item => {
        if (item) {
          item.pbrtime = dayjs(item.pbrtime).format('YYYY-MM-DD HH:mm:ss')
        }
        return item
      })
      console.log(res.data_psu)
      this.psu_Bidding = res.data_psu;
      this.project.prsbjbegtime_YMDHM = dayjs(this.project.prsbjbegtime).format(
        "YYYY年MM月DD日HH时mm分"
      );
      this.project.prsbjbegtime_YMD = dayjs(this.project.prsbjbegtime).format(
        "YYYY年MM月DD日"
      );
      this.project.prsbjendtime_YMDHM = dayjs(this.project.prsbjendtime).format(
        "YYYY年MM月DD日HH时mm分"
      );
      this.project.prsbjendtime_YMD = dayjs(this.project.prsbjendtime).format(
        "YYYY年MM月DD日"
      );
      this.editorCGNRContent = this.project.projectjjcontent;
      this.editorConfirma_Letter_Content = this.project.projectconfirmletter;
      this.btnLoading = false;
      this.loading = false;
    },
    async initEditorCGNR() {
      if (this.editorCGNR && this.project.projectjjcontent) {
        this.editorCGNR.txt.html(this.project.projectjjcontent);
        return;
      }
      this.editorCGNR = new E(this.$refs.editorCGNR);
      this.editorCGNR.config.onchange = (html) => {
        this.editorCGNRContent = html;
      };
      this.editorCGNR.config.uploadFileName = "file";
      this.editorCGNR.config.uploadImgServer = `${config.baseUrl}upload/upload`;
      this.editorCGNR.config.zIndex = 1;
      this.editorCGNR.create();
      if (this.project.projectjjcontent) {
        this.editorCGNR.txt.html(this.project.projectjjcontent);
      }
    },
    async initEditorConfirmletter() {
      if (!this.$refs['editorConfirma_Letter']) {
        return 
      }
      if (this.editorConfirma_Letter && this.project.projectconfirmletter) {
        this.editorConfirma_Letter.txt.html(this.project.projectconfirmletter);
        return;
      }
      this.editorConfirma_Letter = new E(this.$refs.editorConfirma_Letter);
      this.editorConfirma_Letter.config.onchange = (html) => {
        this.editorConfirma_Letter_Content = html;
      };
      this.editorConfirma_Letter.config.uploadFileName = "file";
      this.editorConfirma_Letter.config.uploadImgServer = `${config.baseUrl}upload/upload`;
      this.editorConfirma_Letter.config.zIndex = 1;
      this.editorConfirma_Letter.create();
      if (this.project.projectconfirmletter) {
        this.editorConfirma_Letter.txt.html(this.project.projectconfirmletter);
      }
    },
    async setfile(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: 0,
        appendfromtype: 20,
        appendtype: "100",
        appendseq: this.appendList.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.appendList.push(append);
    },
    async submit(status) {
      if (status === 3) {
        if (+this.projectjjbgstatus < 3) {
          this.$message.warning(`请选择报告结果！`);
          return;
        }
        if (+this.projectjjbgstatus === 4 && !this.checkdesc) {
          this.$message.warning(`请输入审核意见！`);
          return;
        }
      }
      if (status === 2) {
        this.project.projectjjbgstatus = status;
      } else {
        this.project.projectjjbgstatus = this.projectjjbgstatus;
      }
      this.project.projectjjcontent = this.editorCGNRContent;
      this.project.projectconfirmletter = this.editorConfirma_Letter_Content;
      let data = await request({
        url: "/xmgl/project/projectSubmitJjbg",
        method: "post",
        data: {
          projecttype: +this.project.projecttype,
          projectid: this.project.projectid,
          userid: this.$store.getters.loginUser.userid,
          cosid: this.$store.getters.loginUser.cosid,
          projectjjbgstatus: this.project.projectjjbgstatus,
          projectcgcheckdesc: this.checkdesc_Audit,
          projectsubmitdesc: this.checkdesc_submit,
          projectjjcontent: this.project.projectjjcontent,
          projectconfirmletter: this.project.projectconfirmletter,
          appendList: this.appendList,
        },
      });
      if (data.issuccess === 1) {
        let projectjjbgstatusdesc = status === 2 ? "提交" : "保存";
        this.$message.success(`${projectjjbgstatusdesc}成功！`);
        this.getModel();
        this.dialogVisible = false;
        this.status = 0;
        this.close();
      } else {
        this.$message.error(`${projectjjbgstatusdesc}失败！`);
      }
    },
    async checkDialog(status) {
      this.dialogVisible = true;
      this.status = status;
    },
    delappend(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.appendList.findIndex(
            (val) => val.appendfilename === file.appendfilename
          );
          this.appendList.splice(index, 1);
        })
        .catch(() => { });
    },
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "",
      });
    },
    async getTmpl() {
      this.project.pbtList = this.pbtList;
      this.project.psuList = this.psuList;
      this.project.psu_Bidding = this.psu_Bidding;
      this.project.psu_hasNotBidding = [];
      this.project.nowDate = dayjs().format("YYYY年MM月DD日");
      this.project.nowDate_UP = utils
        .ConverToDate(dayjs().format("YYYY"))
        .slice(0, 4);

      this.project.pjnoticetime_UP = dayjs(this.project.pjnoticetime).format(
        "YYYY年MM月DD日"
      );

      // 所有的报价
      this.project.psu_hasBidding = this.psu_Bidding.filter((e) => {
        return e.pbramt !== null
      });

      this.project.psu_hasNotBidding = this.get_hasNoQuote(this.project.psu_hasBidding, this.pbtList)
      // 中标人数
      this.project.bidflgNum = this.psuList.filter((e) => {
        return (e.psubidflg = 1);
      });
      //推荐
      this.project.psu_hasBidding
        .sort((a, b) => {
          return a.psubidorder - b.psubidorder;
        })
        .forEach((e) => {
          e.pbtseq_UP = "第" + utils.upNumbers(e.pbtseq) + "轮";
          e.psubidorder_UP = utils.upNumbers(e.psubidorder);
          e.pbramt_UP =
            "￥" +
            utils.comdify(e.pbramt) +
            "元（" +
            utils.smallToBig(e.pbramt) +
            "）";
        });
      //推荐
      this.project.concludeList = this.project.psu_hasBidding.slice(0, 3)
    },
    //获取最后一轮没有报价的供应商
    /**
     * psu_hasBidding有报价的供应商‘
     * pbtList  所有报价表
     * 
     */
    get_hasNoQuote(psu_hasBidding, pbtList) {
      // 获取最后一轮有报价的人
      let arr = psu_hasBidding.filter(e => {
        return +e.pbtseq === +this.project.prsbjtimes;
      });
      //去重
      return pbtList.filter(item1 => {
        return arr.every(item2 => {
          return +item2.psucomid !== +item1.pbrcomid
        })
      })
    },
    async setReport() {
      if (this.editorCGNRContent) {
        this.$confirm(
          `按模板生成公告，将覆盖现有的公告内容，是否继续？`,
          "提示",
          {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "warning",
          }
        )
          .then(async () => {
            this.getTmpl();
            this.project.projectlimitamtDesc = `${this.project.projectlimitamt}元(${utils.smallToBig(this.project.projectlimitamt)})`
            let CGBG_Con = await this.setContent(
              this.ReportValue,
              this.project
            );
            this.editorCGNRContent = CGBG_Con;
            this.editorCGNR.txt.html(CGBG_Con);
          })
          .catch(() => {
            this.ReportValue = "";
          });
      } else {
        this.getTmpl();
        let CGBG_Con = await this.setContent(this.ReportValue, this.project);
        this.editorCGNRContent = CGBG_Con;
        this.editorCGNR.txt.html(CGBG_Con);
      }
    },
    async setConfirmation() {
      if (this.editorConfirma_Letter_Content) {
        this.$confirm(
          `按模板生成公告，将覆盖现有的公告内容，是否继续？`,
          "提示",
          {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "warning",
          }
        )
          .then(async () => {
            this.getTmpl();
            let confirm_Letter = await this.setContent(
              this.ConfirmationValue,
              this.project
            );
            this.editorConfirma_Letter_Content = confirm_Letter;
            this.editorConfirma_Letter.txt.html(confirm_Letter);
          })
          .catch(() => {
            this.pjnotice.tmplchoose = "";
          });
      } else {
        this.getTmpl();
        let confirm_Letter = await this.setContent(
          this.ConfirmationValue,
          this.project
        );
        this.editorConfirma_Letter_Content = confirm_Letter;
        this.editorConfirma_Letter.txt.html(confirm_Letter);
      }
    },
    async setContent(t, val) {
      let model = {};
      model.selectField = `tmplcontent`;
      model.tmplid = t;
      let res = await request({
        url: "/xmgl/tmpl/getTemplate",
        method: "get",
        params: model,
      });
      let tm = res.tmplcontent;
      let compiled = _.template(tm || "");
      return compiled(val);
    },
    async getTemplateOptions(type) {
      return await request({
        method: "get",
        url: "/xmgl/tmpl/getTemplateOptions",
        params: {
          tmplcosid: this.$store.getters.loginUser.cosid,
          tmpltype: type,
        },
      });
    },
    async sendMsg(status) {
      this.$confirm(`是否确定发送短信`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {

        await this.submit(status)

        let data = await request({
          url: '/xtgl/user/getUser',
          method: 'get',
          params: {
            userid: this.project.projectpuserid
          }
        })

        if (data.length > 0) {
          //尚未完成
          await request({
            url: '/sms/send',
            method: 'get',
            params: {
              type: '5',
              tel: data[0].usercode,
              name: `${this.project.projectname.length > 35 ? this.project.projectname.substring(0, 32) + '...' : this.project.projectname }`
            }
          })

        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/filelist";

.main {

  .from_input .el-input,
  .el-input .el-input__inner,
  .el-select {
    width: 200px;
  }

  .content .el-textarea__inner,
  .el-textarea,
  .el-input {
    width: 690px;
  }

  .file {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;

    .uploadbtn {
      display: flex;

      span {
        padding-left: 10px;
        color: red;
      }
    }
  }
}
</style>

